import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { AppConstant } from 'src/app/utilities/app.constants';
import { CustomDialogService } from '../../../../../shared/custom-dialog.service';

@Component({
  selector: 'app-crew-ratings-chart',
  templateUrl: './crew-ratings-chart.component.html',
  styleUrls: ['./crew-ratings-chart.component.scss']
})
export class CrewRatingsChartComponent implements OnInit, OnChanges {
  chartType = 'lineChart';
  @Input() ratings: [];
  @Input() multiSelectedOptions;
  @Input() avgRatings;
  @Output() chartName = new EventEmitter();

  lineBarChartsData:any[]  = [];
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
  constructor(private customDialogService: CustomDialogService) { }

  ngOnInit() {
    console.log('avgRatings', this.avgRatings);
    // this.prepareDataForLineAndBarCharts();
  }

  ngOnChanges() {
    this.prepareDataForLineAndBarCharts();
    console.log('Ratings', this.ratings);
  }

  prepareDataForLineAndBarCharts() {
    this.lineBarChartsData = [];
    console.log('this.multiSelectedOptions', this.multiSelectedOptions);
    if (this.multiSelectedOptions && this.multiSelectedOptions.values) {
      this.multiSelectedOptions.values.forEach(value => {
        this.lineBarChartsData.push({
          title: value,
          labels: [],
          data: []
        })
      });
    } 
    else {
      this.lineBarChartsData.push({
        title: 'ALL',
        labels: [],
        data: []
      })
    }
  
  // Categorized all the ratings recevied from API into various multi-selected values  
  this.ratings.forEach((ratingInfo: any) => {
    //console.log('ratingInfo', ratingInfo);
    const date = new Date(ratingInfo.createdAt);
    //console.log('ratingInfo date', date);
    //console.log('ratingInfo date', `${this.monthNames[date.getMonth()]}-${date.getFullYear()}`);
    this.lineBarChartsData.forEach(chartData => {
      if (chartData.title === ratingInfo.userInfo[this.multiSelectedOptions.key]) {
        chartData.labels.push(`${this.monthNames[date.getMonth()]}-${date.getFullYear()}`);
        chartData.data.push(ratingInfo.finalRating);
      }
      if(Object.values(this.multiSelectedOptions).length == 0) {
        //console.log('this.multiSelectedOptions', Object.values(this.multiSelectedOptions).length)
        chartData.labels.push(`${this.monthNames[date.getMonth()]}-${date.getFullYear()}`);
        chartData.data.push(ratingInfo.finalRating);
      }
    });
  });
  console.log('after categoried in mutli-option', {...this.lineBarChartsData});

  const allLabels = [];
  // Aggregate and getting AVG of rating received in particular MONTH-YEAR
  this.lineBarChartsData = this.lineBarChartsData.map((lineBarData: any) => {
    const commObject: any = {}; 
    lineBarData.labels.forEach((item, index) => {
      if (commObject.hasOwnProperty(item) ) {
        commObject[item] = commObject[item] + ',' + lineBarData.data[index];
      } else {
        commObject[item] = '0' + lineBarData.data[index];
      }

      // if (commObject[item]) {
      //   commObject[item] = Math.round(commObject[item] * 100) / 100;
      // }

      if (allLabels.indexOf(item) === -1) {
        allLabels.push(item);
      }
    });
    
    lineBarData.labels = Object.keys(commObject);
    lineBarData.data = Object.values(commObject);
    console.log('lineBarData.data', lineBarData.data);
    lineBarData.data = lineBarData.data.map(value => {
      const ratings = value.split(',');
      const count = ratings.length;
      let avgRating = ratings.reduce((total, rating) =>  {
        return +total + + rating 
      }) / count;
      avgRating = Math.round(avgRating * 100) / 100;
      console.log('avgRating', avgRating);
      return avgRating;
    });
    return lineBarData;
    // return commObject;
  })

  console.log('after aggregate monthly', this.lineBarChartsData );

  // Setting last 7 months
  const last7Months = [];
  for (let monthIndex=6; monthIndex>=0; monthIndex--) {
    let date = new Date();
    date.setMonth( date.getMonth() - monthIndex );
    last7Months.push(`${this.monthNames[date.getMonth()]}-${date.getFullYear()}`);
  }
  console.log('last7Months', last7Months);

  allLabels.sort();

  this.lineBarChartsData = this.lineBarChartsData.map(chartData => {
    const last7MonthsData: any = { labels: [...last7Months], data: [undefined, undefined, undefined, undefined, undefined, undefined, undefined]};
    chartData.labels.forEach((item, index) => {
      last7MonthsData.labels.forEach((itemInner, indexInner) => {
        if (itemInner === item) {
          last7MonthsData.data[indexInner] = chartData.data[index];
        }
      });
    });
    chartData.labels = last7MonthsData.labels;
    chartData.data = last7MonthsData.data;
    return chartData;
  });
 }

  setChartType(chartType: string) {
    this.chartType = chartType;
    this.chartName.emit(chartType);
  }
  ratingScale() {
    this.customDialogService.showRatingScaleDialogue(AppConstant.Rating_Scale,'ratingScale');
  }
}
